import { copyRange } from '@/utils/arrayutils'

export default {
  namespaced: true,
  state: {
    commandHistories:
      JSON.parse(sessionStorage.getItem('rest_command_histories')) || []
  },
  mutations: {
    ADD_COMMAND(state, value) {
      const arr = state.commandHistories
      arr.unshift(value)
      const sizeLimit = 20
      if (arr.length > sizeLimit) {
        state.commandHistories = copyRange(arr, 0, sizeLimit)
      }
    }
  },
  actions: {
    addCommand({ commit }, value) {
      commit('ADD_COMMAND', value)
    }
  }
}
